import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    getAiSettingsApi,
    getAiSettingApi,
    saveAiSettingApi,
    getGenerateImageOptionsApi,
} from "../../../../services/setting/aiSettingService";
import {toast} from "react-toastify";

export const getAiSettings = createAsyncThunk(
    'aiSettings/getAiSettings',
    async () => {
        const response = await getAiSettingsApi();
        return response.response;
    }
);

export const getAiSetting = createAsyncThunk(
    'aiSettings/getAiSetting',
    async (feature) => {
        const response = await getAiSettingApi(feature);
        return response.response;
    }
);

export const saveAiSetting = createAsyncThunk(
    'aiSettings/saveAiSetting',
    async ({feature, ...data}) => {
        const response = await saveAiSettingApi(feature, data);
        toast.success("AI settings saved successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    }
);

export const getGenerateImageOptions = createAsyncThunk(
    'aiSettings/getGenerateImageOptions',
    async () => {
        const response = await getGenerateImageOptionsApi();
        return response.response;
    }
);

const aiSettingsSlice = createSlice({
    name: 'aiSettings',
    initialState: {
        settings: [],
        currentSetting: null,
        options: {
            shot_types: [],
            aspect_ratios: [],
        },
        loading: false,
        saving: false,
    },
    reducers: {},
    extraReducers: {
        [getAiSettings.pending]: (state) => {
            state.loading = true;
        },
        [getAiSettings.fulfilled]: (state, action) => {
            state.settings = action.payload;
            state.loading = false;
        },
        [getAiSettings.rejected]: (state) => {
            state.loading = false;
        },
        [getAiSetting.pending]: (state) => {
            state.loading = true;
        },
        [getAiSetting.fulfilled]: (state, action) => {
            state.currentSetting = action.payload;
            state.loading = false;
        },
        [getAiSetting.rejected]: (state) => {
            state.loading = false;
        },
        [saveAiSetting.pending]: (state) => {
            state.saving = true;
        },
        [saveAiSetting.fulfilled]: (state, action) => {
            state.currentSetting = action.payload;
            state.saving = false;
        },
        [saveAiSetting.rejected]: (state) => {
            state.saving = false;
        },
        [getGenerateImageOptions.fulfilled]: (state, action) => {
            state.options = action.payload;
        },
    },
});

export default aiSettingsSlice.reducer;
